<template>
  <div>
<!--    <Tabs value="name1" :animated="false">-->
<!--      <TabPane label="跟进记录" name="name1"><FeedBack :yid="id" type="报名跟进"></FeedBack></TabPane>-->
<!--      <TabPane label="详细信息" name="name2"><ApplyDetailInfo :id="id" :token="token"></ApplyDetailInfo></TabPane>-->
<!--    </Tabs>-->

    <ApplyDetailInfo  :id="id" :token="token"/>

  </div>
</template>

<script>
import ApplyDetailInfo from './ApplyDetailInfo'
import FeedBack from '../common/FeedBack'
export default {
  components:{ApplyDetailInfo,FeedBack},
  props:['id','token'],
}
</script>



// WEBPACK FOOTER //
// src/components/apply/ApplyDetail.vue